const swiperInit = (Swiper) => {
    const element = document.querySelector('[data-testimonial-slider]')
    !element && console.error('No element found with [data-testimonial-slider]')
    const swiperInstance = new Swiper(element, {
        slidesPerView: 1,
        rewind: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 4,
            }
        }
    })
}

if (window.Swiper) { /* Don't import Swiper if its available Globally already */
    swiperInit(Swiper)
} else {
    import('https://cdnjs.cloudflare.com/ajax/libs/Swiper/9.4.1/swiper-bundle.esm.browser.js')
        .then((module) => {
            const Swiper = module.default
            Swiper && swiperInit(Swiper)
        })
        .catch((error) => {
            console.error(`There was an error loading the module: ${error}`);
        });

}